import { HttpErrorResponse } from '@angular/common/http';
import { Response, ResponseCode } from './request-response';
import Bugsnag from '@bugsnag/js';

export class ErrorResponse extends Response implements Error {
    public name = 'ErrorResponse';
    public stack?: string;
    public message = 'A server error occurred.';
    public code: ResponseCode = ResponseCode.Error;

    constructor(
        errorResponse: HttpErrorResponse | Response | { code: ResponseCode; message?: string }
    ) {
        super();

        if (errorResponse instanceof HttpErrorResponse) {
            this.code = errorResponse.status;
            if (errorResponse.error) {
                let error = errorResponse.error;
                try {
                    error = JSON.parse(errorResponse.error);
                } catch (e) {
                    // swallow JSON parse error
                    Bugsnag.notify(e);
                }

                if (typeof error.error === 'string') {
                    error = JSON.parse(error.error);
                } else if (typeof error.error === 'object') {
                    error = error.error;
                }

                this.message = error.message || error || this.message;
            }
        } else {
            this.code = errorResponse.code ?? ResponseCode.Error;
            this.message = errorResponse.message;
        }
    }
}
